<section class="max-w-5xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
    <div class="bg-white rounded-3xl shadow-sm border border-zinc-200 p-6 sm:p-8 lg:p-12">

        <!-- Header -->
        <div class="mb-10 text-center">
            <h1 class="text-3xl sm:text-4xl font-bold text-zinc-900 mb-4 leading-tight">{{ 'usagePolicy.header.title' |
                translate }}</h1>

            <div class="w-24 h-1 bg-black mx-auto rounded-full"></div>
            <p class="mt-4 text-zinc-600">{{ 'usagePolicy.header.subtitle' | translate }}</p>
        </div>

        <!-- Content -->
        <div class="space-y-8 text-zinc-700 text-[15px] sm:text-base leading-8">

            <p class="text-lg leading-9 text-zinc-600">{{ 'usagePolicy.intro' | translate }}</p>

            <!-- Section -->
            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black ">{{
                    'usagePolicy.registration.title' | translate }}</h2>

                <p>{{ 'usagePolicy.registration.p1' | translate }}</p>
            </div>

            <!-- Section -->
            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black ">{{
                    'usagePolicy.publishing.title' | translate }}</h2>

                <div class="space-y-4">
                    <p>{{ 'usagePolicy.publishing.p1' | translate }}</p>
                    <p>{{ 'usagePolicy.publishing.p2' | translate }}</p>
                    <p>{{ 'usagePolicy.publishing.p3' | translate }}</p>
                </div>
            </div>

            <!-- Section -->
            <div class="space-y-4">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black ">{{
                    'usagePolicy.payments.title' | translate }}</h2>

                <p>{{ 'usagePolicy.payments.p1' | translate }}</p>
            </div>

            <!-- Section -->
            <div class="space-y-5">
                <h2 class="text-xl sm:text-2xl font-semibold text-zinc-900 border-s-4 px-5 border-black ">{{
                    'usagePolicy.privacy.title' | translate }}</h2>

                <div class="space-y-5">
                    <p>{{ 'usagePolicy.privacy.p1' | translate }}</p>
                    <p>{{ 'usagePolicy.privacy.p2' | translate }}</p>
                    <p>{{ 'usagePolicy.privacy.p3' | translate }}</p>
                    <p>{{ 'usagePolicy.privacy.p4' | translate }}</p>
                    <p>{{ 'usagePolicy.privacy.p5' | translate }}</p>
                    <p>{{ 'usagePolicy.privacy.p6' | translate }}</p>
                    <p>{{ 'usagePolicy.privacy.p7' | translate }}</p>
                    <p>{{ 'usagePolicy.privacy.p8' | translate }}</p>
                    <p>{{ 'usagePolicy.privacy.p9' | translate }}</p>
                    <p class="mt-4">{{ 'usagePolicy.jurisdiction.p1' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</section>